import React, { JSX } from 'react'
import { Box, Grid, Text } from '@chakra-ui/react'

import i18n from 'utils/i18n'

const enDaysNames = ['M', 'T', 'W', 'T', 'F', 'S', 'S']
const noDaysNames = ['m', 't', 'o', 't', 'f', 'l', 's']

export const WeekDays = (): JSX.Element => {
  const currentLocale = i18n.language
  const daysNames = currentLocale === 'no' ? noDaysNames : enDaysNames

  return (
    <Grid templateColumns="repeat(7, auto)" justifyContent="space-between" marginBottom="10px">
      {daysNames.map((day, index) => (
        <Box key={index} textAlign="center" width="24px">
          <Text fontSize="xxs" color="green.a200" fontWeight={600}>
            {day}
          </Text>
        </Box>
      ))}
    </Grid>
  )
}
